import { observable } from 'mobx';

export interface OnlineApplicationPlanArgs {
  id: number;
  online_application_id?: number;
  name: string;
  plan_id: number;
  plan_master_name?: string;
  price: number;
  created_at?: string;
  updated_at?: string;
}

export class OnlineApplicationPlan {
  @observable id: number;
  @observable onlineApplicationId?: number;
  @observable name: string;
  @observable planId: number;
  @observable planMasterName?: string;
  @observable price: number;
  @observable createdAt?: string;
  @observable updatedAt?: string;

  constructor(args: Partial<OnlineApplicationPlanArgs> = {}) {
    this.id = args.id || 0;
    this.onlineApplicationId = args.online_application_id;
    this.name = args.name || 'AI Travel 出張管理システム サービス利用基本料金';
    this.planId = args.plan_id || 1;
    this.planMasterName = args.plan_master_name || (args as any).planMasterName;
    this.price = args.price || 0;
    this.createdAt = args.created_at;
    this.updatedAt = args.updated_at;
  }
}

export default OnlineApplicationPlan;
